// This icon file is generated automatically.
var PMinusCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M9.88 6.5H4.12a.13.13 0 00-.12.13v.75c0 .06.06.12.13.12h5.75c.06 0 .12-.06.12-.13v-.75a.13.13 0 00-.13-.12z" } }, { "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8z" } }] }] }, "name": "p-minus-circle", "theme": "outlined" };
export default PMinusCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PMinusCircleOutlined.js
// module id = 3513
// module chunks = 0